// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".autoAddressClass li i.el-icon-search[data-v-c0e5acd2] {\n  margin-top: 11px;\n}\n.autoAddressClass li .mgr10[data-v-c0e5acd2] {\n  margin-right: 10px;\n}\n.autoAddressClass li .title[data-v-c0e5acd2] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.autoAddressClass li .address[data-v-c0e5acd2] {\n  line-height: 1;\n  font-size: 12px;\n  color: #b4b4b4;\n  margin-bottom: 5px;\n}", ""]);
// Exports
module.exports = exports;
